export default __webpack_public_path__ + "static/media/newProduct.af3e6ee3.png";